<template>
  <span>
    <span v-if="data && data.length">
      <b-badge
        variant="primary"
        v-for="datum in data"
        :key="data.indexOf(datum)"
        class="mr-1"
      >{{datum ? datum[dataKey] : ''}}</b-badge>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    dataKey: {
      type: String,
      required: true
    }
  }
};
</script>
